// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"6db6b87b","434":"ec61df4b","864":"72667a65"}[chunkId] + ".chunk.css";
};